import React from "react";

const PRESETS = [
  { label: "1h", hours: 1 },
  { label: "6h", hours: 6 },
  { label: "12h", hours: 12 },
  { label: "24h", hours: 24 },
  { label: "Full", hours: null },
];

export const StcTimeRangeBar = ({ selected, onSelect }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        gap: 6,
        padding: "8px 0",
        width: "100%",
      }}
    >
      {PRESETS.map((preset) => (
        <button
          key={preset.label}
          onClick={() => onSelect(preset.hours)}
          style={{
            padding: "6px 14px",
            fontSize: 13,
            fontWeight: selected === preset.hours ? 700 : 400,
            border: "1px solid #555",
            borderRadius: 4,
            backgroundColor:
              selected === preset.hours ? "#4a90d9" : "#3a3e47",
            color: "#fff",
            cursor: "pointer",
            minWidth: 44,
          }}
        >
          {preset.label}
        </button>
      ))}
    </div>
  );
};
